import React from "react";

const BackButton = ({ onClick, label = "Back", showIcon = true }) => {
  return (
    <button
      className="flex items-center gap-2 text-gray-800 font-medium mb-8"
      onClick={onClick}
    >
      {showIcon && <span className="text-xl">←</span>}
      {label}
    </button>
  );
};

export default BackButton;
